import { createAsyncThunk } from '@reduxjs/toolkit'
import {
  addOptionsService,
  closeQuestionService,
  createCategoryService,
  updateCategoryStatusService,
  createQuestionService,
  editOptionService,
  editQuestionService,
  getCategoriesService,
  getMarketsService,
  getRecentTradesService,
  getQuestionDetailsService,
  // getSettledOptionsService,
  getTopHoldersService,
  getTradeSummaryService,
  getQuestionSummaryService,
  getTradingFeeReportService,
  getTranslationService,
  promoteToBreakingService,
  removeFromBreakingService,
  updateOptionStateService
} from 'network/services/predictionMarket.service'
import { getEventsService } from 'network/services/polymarket.service'

export const getMarkets = createAsyncThunk('predictionMarket/getMarkets', async (params, thunkApi) => {
  try {
    return await getMarketsService(params)
  } catch (error) {
    return thunkApi.rejectWithValue(error[0]?.description || 'Failed to fetch markets')
  }
})

export const getQuestionDetails = createAsyncThunk('predictionMarket/getQuestionDetails', async (params, thunkApi) => {
  try {
    return await getQuestionDetailsService(params)
  } catch (error) {
    return thunkApi.rejectWithValue(error[0]?.description || 'Failed to fetch question details')
  }
})

export const getCategories = createAsyncThunk('predictionMarket/getCategories', async (params, thunkApi) => {
  try {
    return await getCategoriesService(params)
  } catch (error) {
    return thunkApi.rejectWithValue(error[0]?.description || 'Failed to fetch categories')
  }
})

export const updateCategoryStatus = createAsyncThunk('predictionMarket/updateCategoryStatus', async (data, thunkApi) => {
  try {
    return await updateCategoryStatusService(data)
  } catch (error) {
    return thunkApi.rejectWithValue(error[0]?.description || 'Failed to update category')
  }
})

export const createCategory = createAsyncThunk('predictionMarket/createCategory', async (data, thunkApi) => {
  try {
    return await createCategoryService(data)
  } catch (error) {
    return thunkApi.rejectWithValue(error[0]?.description || 'Failed to create category')
  }
})

export const createQuestion = createAsyncThunk('predictionMarket/createQuestion', async (data, thunkApi) => {
  try {
    return await createQuestionService(data)
  } catch (error) {
    return thunkApi.rejectWithValue(error[0]?.description || 'Failed to create question')
  }
})

export const editQuestion = createAsyncThunk('predictionMarket/editQuestion', async (data, thunkApi) => {
  try {
    return await editQuestionService(data)
  } catch (error) {
    return thunkApi.rejectWithValue(error[0]?.description || 'Failed to update question')
  }
})

export const editOption = createAsyncThunk('predictionMarket/editOption', async (data, thunkApi) => {
  try {
    return await editOptionService(data)
  } catch (error) {
    return thunkApi.rejectWithValue(error[0]?.description || 'Failed to update option')
  }
})

export const closeQuestion = createAsyncThunk('predictionMarket/closeQuestion', async (data, thunkApi) => {
  try {
    return await closeQuestionService(data)
  } catch (error) {
    return thunkApi.rejectWithValue(error[0]?.description || 'Failed to close question')
  }
})

export const promoteToBreaking = createAsyncThunk('predictionMarket/promoteToBreaking', async (data, thunkApi) => {
  try {
    return await promoteToBreakingService(data)
  } catch (error) {
    return thunkApi.rejectWithValue(error[0]?.description || 'Failed to promote market')
  }
})

export const removeFromBreaking = createAsyncThunk('predictionMarket/removeFromBreaking', async (data, thunkApi) => {
  try {
    return await removeFromBreakingService(data)
  } catch (error) {
    return thunkApi.rejectWithValue(error[0]?.description || 'Failed to remove breaking promotion')
  }
})

export const addOptions = createAsyncThunk('predictionMarket/addOptions', async (data, thunkApi) => {
  try {
    return await addOptionsService(data)
  } catch (error) {
    return thunkApi.rejectWithValue(error[0]?.description || 'Failed to add option')
  }
})

export const updateOptionState = createAsyncThunk('predictionMarket/updateOptionState', async (data, thunkApi) => {
  try {
    return await updateOptionStateService(data)
  } catch (error) {
    return thunkApi.rejectWithValue(error[0]?.description || 'Failed to update option state')
  }
})

export const getSettledOptions = createAsyncThunk('predictionMarket/getSettledOptions', async (params, thunkApi) => {
  try {
    return // await getSettledOptionsService(params)
  } catch (error) {
    return thunkApi.rejectWithValue(error[0]?.description || 'Failed to fetch settled options')
  }
})

export const getRecentTrades = createAsyncThunk('predictionMarket/getRecentTrades', async (params, thunkApi) => {
  try {
    return await getRecentTradesService(params)
  } catch (error) {
    return thunkApi.rejectWithValue(error[0]?.description || 'Failed to fetch recent trades')
  }
})

export const getTopHolders = createAsyncThunk('predictionMarket/getTopHolders', async (params, thunkApi) => {
  try {
    return await getTopHoldersService(params)
  } catch (error) {
    return thunkApi.rejectWithValue(error[0]?.description || 'Failed to fetch top holders')
  }
})

export const getTradeSummary = createAsyncThunk('predictionMarket/getTradeSummary', async (params, thunkApi) => {
  try {
    return await getTradeSummaryService(params)
  } catch (error) {
    return thunkApi.rejectWithValue(error[0]?.description || 'Failed to fetch trade summary')
  }
})

export const getQuestionSummary = createAsyncThunk('predictionMarket/getQuestionSummary', async (params, thunkApi) => {
  try {
    return await getQuestionSummaryService(params)
  } catch (error) {
    return thunkApi.rejectWithValue(error[0]?.description || 'Failed to fetch question summary')
  }
})

export const getTradingFeeReport = createAsyncThunk('predictionMarket/getTradingFeeReport', async (params, thunkApi) => {
  try {
    return await getTradingFeeReportService(params)
  } catch (error) {
    return thunkApi.rejectWithValue(error[0]?.description || 'Failed to fetch trading fees')
  }
})

export const getEvents = createAsyncThunk('predictionMarket/getEvents', async (params, thunkApi) => {
  try {
    return await getEventsService(params)
  } catch (error) {
    return thunkApi.rejectWithValue(error[0]?.description || 'Failed to fetch external events')
  }
})

export const getTranslation = createAsyncThunk('predictionMarket/getTranslation', async (data, thunkApi) => {
  try {
    return await getTranslationService(data)
  } catch (error) {
    return thunkApi.rejectWithValue(error[0]?.description || 'Failed to fetch translations')
  }
})
